import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
export function useRefs() {
  const [refs, setRefs] = useState(cache);
  useEffect(() => { if (!cache) api.get("/referentiels").then((r) => { cache = r.data; setRefs(r.data); }); }, []);
  return refs;
}

export const versOptions = (obj) => Object.entries(obj || {}).map(([code, label]) => ({ code, label }));
export const listeOptions = (arr) => (arr || []).map((v) => ({ code: v, label: v }));

export async function telecharger(url, params, nom) {
  const { data } = await api.get(url, { params, responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(data);
  a.download = nom;
  a.click();
}
